import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "form__section-title"
};
const _hoisted_2 = {
    key: 0,
    class: "form__bulk-select"
};
const _hoisted_3 = ["checked"];
const _hoisted_4 = {
    key: 2,
    class: "form__validation"
};
import { getCurrentInstance, ref, shallowRef, computed } from 'vue';
import FormLabel from "./FormLabel.vue";
import FieldControlText from "./FieldControlText.vue";
import FieldControlForm from "./FieldControlForm.vue";
import FieldControlTable from "./FieldControlTable.vue";
import FormUtils from "./FormUtils";
import FieldControlNumber from "./FieldControlNumber.vue";
import FieldControlBool from "./FieldControlBool.vue";
import FieldControlBoolSelect from "./FieldControlBoolSelect.vue";
import FieldControlTextarea from "./FieldControlTextarea.vue";
import FieldControlChoiceExpanded from "./FieldControlChoiceExpanded.vue";
import FieldControlChoiceSelection from "./FieldControlChoiceSelection.vue";
import FieldControlEntity from "./FieldControlEntity.vue";
import FieldControlDate from "./FieldControlDate.vue";
import FieldControlDatetime from "./FieldControlDatetime.vue";
import FieldControlFile from "./FieldControlFile.vue";
import FieldControlInfo from "./FieldControlInfo.vue";
import FieldControlRangeTime from "./FieldControlRangeTime.vue";
import FieldControlJson from "./FieldControlJson.vue";
import FieldControlPassword from "./FieldControlPassword.vue";
import FieldControlSecret from "./FieldControlSecret.vue";
import FieldControlCredentials from "./FieldControlCredentials.vue";
import log from "../../services/Logger";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormGroup',
    props: {
        form: {},
        field: {},
        data: {},
        validation: {},
        mode: {},
        fieldPrefix: {},
        submitted: { type: Boolean },
        hideLabel: { type: Boolean }
    },
    emits: [
        'change',
        'bulk-select-toggle',
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const fieldNameEscaped = escapeClass(props.field.name);
        const fieldOptions = computed(() => props.field.options || {});
        const fieldControl = ref(null);
        const controlComponent = shallowRef(null);
        const fieldId = ref(props.form.name + '_' + fieldNameEscaped + '_' + FormUtils.fieldIdSeq++);
        const fieldPath = ref(!props.fieldPrefix
            ? props.field.name
            : props.fieldPrefix + '.' + props.field.name);
        const groupClasses = computed(() => {
            const classes = [];
            if (fieldOptions.value.required && fieldControl.value !== 'boolean') {
                classes.push('form__group--required');
            }
            classes.push('form__group--field-' + fieldControl.value);
            classes.push('form__group--field-' + props.field.type);
            classes.push('form__group--attribute-' + fieldNameEscaped);
            if (fieldControl.value === 'choice' && fieldOptions.value.expanded) {
                classes.push('form__group--choice-expanded');
            }
            if (fieldControl.value === 'boolean' && !fieldOptions.value.required) {
                classes.push('form__group--field-boolean-select');
            }
            if (focussed.value) {
                classes.push('form__group--active');
            }
            if ((touched.value || (props.submitted ?? false)) && hasValidationErrors()) {
                classes.push('form__group--invalid');
            }
            if (props.mode === 'bulk' && fieldOptions.value.disabled) {
                classes.push('form__group--bulk-ignored');
            }
            return classes;
        });
        const touched = ref(props.submitted ?? false);
        const focussed = ref(false);
        fieldControl.value = getFieldControl();
        controlComponent.value = getControlComponent();
        function onChange(data) {
            log('FormGroup@change', props.field.name, data);
            emit('change', data);
        }
        function onFocus() {
            focussed.value = true;
            getCurrentInstance()?.proxy?.$forceUpdate();
        }
        function onBlur() {
            touched.value = true;
            focussed.value = false;
            getCurrentInstance()?.proxy?.$forceUpdate();
        }
        function hasValidationErrors() {
            const fieldValidation = props.validation.fields[fieldPath.value];
            return (fieldValidation && fieldValidation.length > 0);
        }
        function isSelection(field) {
            return FormUtils.isSelectionField(field, fieldControl.value);
        }
        function toggleBulk() {
            emit('bulk-select-toggle', fieldPath.value);
        }
        function getControlComponent() {
            if (fieldOptions.value.component) {
                return fieldOptions.value.component;
            }
            switch (fieldControl.value) {
                case 'textarea':
                case 'html': // TODO
                    return FieldControlTextarea;
                case 'json':
                    return FieldControlJson;
                case 'boolean':
                    return fieldOptions.value.required
                        ? FieldControlBool
                        : FieldControlBoolSelect;
                case 'choice':
                    return fieldOptions.value.expanded
                        ? FieldControlChoiceExpanded
                        : FieldControlChoiceSelection;
                case "date":
                    return FieldControlDate;
                case "datetime":
                    return FieldControlDatetime;
                case "entity":
                    return FieldControlEntity;
                case 'number':
                    return FieldControlNumber;
                // case "number-string":
                //     break;
                // case "currency":
                //     break;
                // case "currency-string":
                //     break;
                case 'form':
                    return FieldControlForm;
                case 'table':
                    return FieldControlTable;
                case "file":
                    return FieldControlFile;
                // case "autocomplete":
                //     break;
                case 'range_time':
                    return FieldControlRangeTime;
                case 'input':
                    return FieldControlText;
                case 'info':
                    return FieldControlInfo;
                case 'password':
                    return FieldControlPassword;
                case 'secret':
                    return FieldControlSecret;
                case 'credentials':
                    return FieldControlCredentials;
            }
            throw 'Unsupported field control: ' + fieldControl.value;
        }
        function getFieldControl() {
            const opts = props.field.options || {};
            // TODO implement all field types
            switch (props.field.type) {
                case 'textarea':
                case 'code':
                    // return opts.localized ? 'localized-textarea' : 'textarea';
                    return 'textarea';
                case 'html':
                    // return opts.localized ? 'localized-html' : 'html';
                    return 'html';
                case 'json':
                    return 'json';
                case 'bool':
                    return 'boolean';
                case 'choice':
                case 'country':
                    return 'choice';
                case 'date':
                    return 'date';
                case 'datetime':
                case 'datetime_local':
                    return 'datetime';
                case 'entity':
                    return 'entity';
                case 'number':
                    // return opts.jsonType === 'string' ? 'number-string' : 'number';
                    return 'number';
                case 'currency':
                    // return opts.jsonType === 'string' ? 'currency-string' : 'currency';
                    return 'number';
                case 'form':
                    return 'form';
                case 'table':
                    return 'table';
                // case 'codemirror':
                //     return 'codemirror';
                // case 'time':
                //     return 'time';
                case 'file':
                    return 'file';
                // case 'localized_text':
                //     return 'localized-text';
                // case 'localized_textarea':
                //     return 'localized-textarea';
                // case 'localized_html':
                //     return 'localized-html';
                // case 'section':
                //     return 'section';
                case 'range_time':
                    return 'range_time';
                case 'info':
                    return 'info';
                case 'password':
                    return 'password';
                case 'secret':
                    return 'secret';
                case 'credentials':
                    return 'credentials';
                default:
                    return 'input';
            }
        }
        function escapeClass(value) {
            return value.replace(/\./g, '-');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["form__group", groupClasses.value])
            }, [
                (__props.field.type === 'section')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.field.label || _ctx.$t(__props.form.name + '_' + __props.field.label)), 1))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (__props.mode === 'bulk')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("input", {
                                    type: "checkbox",
                                    name: "bulk-selected",
                                    checked: !fieldOptions.value.disabled,
                                    onClick: _cache[0] || (_cache[0] = ($event) => (toggleBulk()))
                                }, null, 8, _hoisted_3)
                            ]))
                            : _createCommentVNode("", true),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (!__props.hideLabel)
                            ? (_openBlock(), _createBlock(FormLabel, {
                                key: 1,
                                form: __props.form,
                                field: __props.field,
                                "field-id": fieldId.value
                            }, null, 8, ["form", "field", "field-id"]))
                            : _createCommentVNode("", true),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("div", {
                            class: _normalizeClass(["form__control-wrapper", {
                                    'form__control-wrapper--nested': fieldControl.value === 'form' || fieldControl.value === 'table',
                                    'form__control-wrapper--table': fieldControl.value === 'table',
                                    'form__selection': isSelection(__props.field)
                                }])
                        }, [
                            (fieldOptions.value.componentBefore)
                                ? (_openBlock(), _createBlock(_resolveDynamicComponent(fieldOptions.value.componentBefore), {
                                    key: 0,
                                    data: __props.data,
                                    field: __props.field,
                                    form: __props.form,
                                    validation: __props.validation,
                                    params: fieldOptions.value.params,
                                    submitted: __props.submitted ?? false
                                }, null, 8, ["data", "field", "form", "validation", "params", "submitted"]))
                                : _createCommentVNode("", true),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            (_openBlock(), _createBlock(_resolveDynamicComponent(controlComponent.value), {
                                form: __props.form,
                                field: __props.field,
                                "field-prefix": __props.fieldPrefix ?? '',
                                "field-id": fieldId.value,
                                data: __props.data,
                                validation: __props.validation,
                                submitted: __props.submitted ?? false,
                                onChange: onChange,
                                onFocus: onFocus,
                                onBlur: onBlur
                            }, null, 40, ["form", "field", "field-prefix", "field-id", "data", "validation", "submitted"])),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            (fieldOptions.value.componentAfter)
                                ? (_openBlock(), _createBlock(_resolveDynamicComponent(fieldOptions.value.componentAfter), {
                                    key: 1,
                                    data: __props.data,
                                    field: __props.field,
                                    form: __props.form,
                                    validation: __props.validation,
                                    params: fieldOptions.value.params,
                                    submitted: __props.submitted ?? false
                                }, null, 8, ["data", "field", "form", "validation", "params", "submitted"]))
                                : _createCommentVNode("", true)
                        ], 2),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        ((touched.value || (__props.submitted ?? false)) && hasValidationErrors())
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.validation.fields[fieldPath.value], (error, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: index,
                                        class: "form__validation-item"
                                    }, _toDisplayString((typeof error === "string") ? _ctx.$t(error) : error.message), 1));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true)
                    ], 64))
            ], 2));
        };
    }
});
